/* eslint-disable react-hooks/exhaustive-deps */
import React, {useContext, useEffect} from "react";
import AppContainer from "../../Components/Structure/AppContainer";
import {Link} from "react-router-dom";
import useStateCallback from "../../util/customHooks/useStateCallback";
import {Toaster} from "react-hot-toast";
import TableHeader from "../../Components/Common/TableHeader";
import Loader from "../../Components/Common/Loader";
import Col from "react-bootstrap/Col";
import Nav from "react-bootstrap/Nav";
import Row from "react-bootstrap/Row";
import Tab from "react-bootstrap/Tab";
import StationContext from "../../Context/StationContext";
import AddSetting from "../../Components/Settings/StationSettings/AddSetting";
import StationSettingsTable from "../../Components/Common/Settings/StationSettings/StationSettingsTable";
import EnableAuthMethod from "../../Components/Settings/StationSettings/EnableAuthMethod";
import DisableAuthMethod from "../../Components/Settings/StationSettings/DisableAuthMethod";

function AuthenticationSettingsPage() {

    const {globalStationSettings, getGlobalStationSettings, stationSettings, getStationSettings, schoolStationSettings, getSchoolStationSettings, loading} = useContext(StationContext);
    const [modal, setModal] = useStateCallback(false);

    useEffect(() => {
        getGlobalStationSettings();
        getSchoolStationSettings();
        getStationSettings();
    }, []);

    const refreshData = () =>{
        getGlobalStationSettings();
        getSchoolStationSettings();
        getStationSettings();
    }

    const handleEnable=(e,item)=>{
        setModal(false, ()=>setModal(<EnableAuthMethod settingID={item.setting_id} g={getGlobalStationSettings} h={getSchoolStationSettings} i={getStationSettings} isOpen={true}/>))
    }

    const handleDisable=(e,item)=>{
        setModal(false, ()=>setModal(<DisableAuthMethod settingID={item.setting_id} g={getGlobalStationSettings} h={getSchoolStationSettings} i={getStationSettings} isOpen={true}/>))
    }


    return (
        <AppContainer title="Booth Authentication Settings">
            <Toaster position="top-center" reverseOrder={false} />
            {modal}
            <div className="row">
                

                <div className="col-lg-4">
                    <AddSetting g={getGlobalStationSettings} h={getSchoolStationSettings} i={getStationSettings}/>
                </div>

                <div className="col-lg-8">
                    <div className="card custom-card" style={{borderRadius: "10px"}}>
                        <div className="card-body map-card">
                            <div class="heading-layout1 mg-b-25">
                                <TableHeader
                                title="Booth Authentication Settings"
                                subtitle="List of all the booth authentication settings"
                                />
                                <div class="dropdown">
                                <Link class="dropdown-toggle" role="button" data-toggle="dropdown" aria-expanded="false">...</Link>
                                <div class="dropdown-menu dropdown-menu-right">
                                    <Link class="dropdown-item" onClick={refreshData} ><i class="fas fa-redo-alt text-orange-peel"></i>Refresh</Link>
                                </div>
                                </div>
                            </div>
                                        
                            <Tab.Container id="left-tabs-example" defaultActiveKey="first">
                                <Row>
                                <Col sm={12}>
                                <Nav variant="pills" className="flex-row mb-1">
                                <Nav.Item>
                                    <Nav.Link size="sm" eventKey="first">
                                        Global Settings{" "}
                                    </Nav.Link>
                                </Nav.Item>
                                <Nav.Item>
                                    <Nav.Link size="sm" eventKey="second">
                                    School Settings{" "}
                                    </Nav.Link>
                                </Nav.Item>
                                <Nav.Item>
                                    <Nav.Link size="sm" eventKey="third">
                                    Booth / Station Settings{" "}
                                    </Nav.Link>
                                </Nav.Item>
                                </Nav>
                            </Col>

                            <Col sm={12}>
                                <Tab.Content>
                                <Tab.Pane eventKey="first">
                                    <div className="border-top mt-1"></div>
                                    <div className="table-responsive">
                                        {loading? (
                                            <Loader /> 
                                        ) : (
                                        <StationSettingsTable settingList={globalStationSettings} handleEnable={handleEnable}  handleDisable={handleDisable} scopeType="global"/>
                                        )}
                            
                                    </div>
                                </Tab.Pane>

                                <Tab.Pane eventKey="second">
                                    <div className="border-top mt-1"></div>
                                    <div className="table-responsive">
                                        {loading? (
                                                <Loader /> 
                                            ) : (
                                            <StationSettingsTable settingList={schoolStationSettings} handleEnable={handleEnable} handleDisable={handleDisable} scopeType="school"/>
                                        )}
                                    </div>

                                </Tab.Pane>

                                <Tab.Pane eventKey="third">
                                    <div className="border-top mt-1"></div>
                                    <div className="table-responsive">
                                        {loading? (
                                                <Loader /> 
                                            ) : (
                                            <StationSettingsTable settingList={stationSettings} handleEnable={handleEnable} handleDisable={handleDisable} scopeType="station"/>
                                        )}
                                    </div>

                                </Tab.Pane>
                                </Tab.Content>
                            </Col>
                            </Row>
                            </Tab.Container>                
                                                        
                        </div>
                    </div>
                </div>
            </div>
        </AppContainer>
    );
}

export default AuthenticationSettingsPage;
